export const geoApiOptions = {
  method: 'GET',
  headers: {
    'X-RapidAPI-Key': '98adc8acf9msh4f813baf9f6fbfap134dd7jsnb928acc7e1b4',
    'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com',
  },
};

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo';

export const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5';

export const WEATHER_API_KEY = 'd1a8c55297c3e49daf85c68e8e364a72';
